module.exports = require("./uz");